module.exports = __webpack_public_path__ + "img/pt6.530ae439.jpg";